import { render, staticRenderFns } from "./editComponent.vue?vue&type=template&id=e4f58280&scoped=true&"
import script from "./editComponent.vue?vue&type=script&lang=js&"
export * from "./editComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f58280",
  null
  
)

export default component.exports